import type { AssetComponentCreateDto, AssetComponentDto, AssetComponentUpdateDto, AssetComponentWithNavigationPropertiesDto, GetAssetComponentsInput } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class AssetComponentService {
  apiName = 'Inventory';

  create = (input: AssetComponentCreateDto) =>
    this.restService.request<any, AssetComponentDto>({
      method: 'POST',
      url: '/api/inventory/asset-components',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/asset-components/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, AssetComponentDto>({
      method: 'GET',
      url: `/api/inventory/asset-components/${id}`,
    },
    { apiName: this.apiName });

  getAssetLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/asset-components/asset-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getComponentLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/asset-components/component-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getList = (input: GetAssetComponentsInput) =>
    this.restService.request<any, PagedResultDto<AssetComponentWithNavigationPropertiesDto>>({
      method: 'GET',
      url: '/api/inventory/asset-components',
      params: { filterText: input.filterText, code: input.code, assetId: input.assetId, componentId: input.componentId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getWithNavigationProperties = (id: string) =>
    this.restService.request<any, AssetComponentWithNavigationPropertiesDto>({
      method: 'GET',
      url: `/api/inventory/asset-components/with-navigation-properties/${id}`,
    },
    { apiName: this.apiName });

  update = (id: string, input: AssetComponentUpdateDto) =>
    this.restService.request<any, AssetComponentDto>({
      method: 'PUT',
      url: `/api/inventory/asset-components/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
